import {createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {rxInit} from "./appSlice";

const budgetsAdapter = createEntityAdapter({
  sortComparer: (a, b) => a.position - b.position
});

const initialState = {
  budgets: budgetsAdapter.getInitialState(),

  editor: {
    show: false,
    mode: null
  }
};

export const budgetsSlice = createSlice({
  name: "budgets",
  initialState,
  reducers: {
    showEditor: (state, action) => {
      state.editor.show = true;
      state.editor.mode = action.payload.mode;
      state.editor.budget = action.payload.budget;
    },

    hideEditor: state => {
      state.editor.show = false;
    },

    submitEditor: (state, action) => {
      budgetsAdapter.setMany(state.budgets, action.payload);
    },

    updateBudgets: (state, action) => {
      budgetsAdapter.setMany(state.budgets, action.payload);
    },

    reorderBudgets: (state, action) => {
      let position = 1;

      budgetsAdapter.setMany(state.budgets, action.payload.map(a => ({...a, position: position++})));
    }
  },
  extraReducers: builder => {
    builder.addCase(rxInit, (state, action) => {
      budgetsAdapter.setMany(state.budgets, action.payload.budgets);
    });
  }
});

export const {
  showEditor: rxShowBudgetEditor,
  hideEditor: rxHideBudgetEditor,
  submitEditor: rxSubmitBudgetEditor,
  updateBudgets: rxUpdateBudgets,
  reorderBudgets: rxReorderBudgets
} = budgetsSlice.actions;

export const {selectAll: selectAllBudgets} = budgetsAdapter.getSelectors(state => state.budgets.budgets);

export const editorConfigSelector = state => state.budgets.editor;

export default budgetsSlice.reducer;
